import { render } from "./OngoingProjectDetails.vue?vue&type=template&id=0cc30f18"
import script from "./OngoingProjectDetails.vue?vue&type=script&lang=js"
export * from "./OngoingProjectDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__